import Vue from 'vue';
import {
  getFontAwesomeIconFromMIME,
  checkBrowserSupportForMIME,
  checkImageTagSupportForMIME } from '@/misc/mime';

export default {
  data() {
    return {
      attachment_mime: [],
      attachment_uploading: false,
      attachment_scope: 'last'
    }
  },
  watch: {
    'attachment_id_list': {
      handler(load_list) {
        // console.log("WATCHER:attachment_id_list", load_list)
        load_list.forEach(attachment_id => {
          this.$api.task_file_get_metadata({
            goal_id: this.goalId,
            task_id: this.task.$id,
            attachment_id: attachment_id
          }).then(metadata => {
            Vue.set(this.attachment_mime, attachment_id, {
              size: metadata.size,
              type: metadata.contentType,
              icon: getFontAwesomeIconFromMIME(metadata.contentType),
              supported: checkBrowserSupportForMIME(metadata.contentType),
              preview: checkImageTagSupportForMIME(metadata.contentType),
              // TODO: Save original file name and display it
            });
          })
        })
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    attachment_id_preview() {
      if ( this.task.attachments ) {
        return this.attachment_id_list.length > 0 ? this.attachment_id_list[0] : null;
      }
      return false;
    },
    attachment_id_list() {

      if ( ( this.task_ready || ( this.task && this.task.$ready ) ) && this.task.attachments ) {
        // This could be any index! Objects don't necessarly have an order.
        let id_list = Object.keys( this.task.attachments )
        if ( this.attachment_scope === 'first' ) {
          return id_list.length > 0 ? id_list[0] : [];
        } else if ( this.attachment_scope === 'last') {
          return [ id_list.pop() ];
        } else if ( this.attachment_scope === 'all' ) {
          return id_list;
        }
      }
      return [];
    }
  },
  methods: {
    setAttachmentScope(scope = 'all') {
      this.attachment_scope = scope;
    },

    _memberId() {
      return this.task.memberId || this.memberId;
    },

    onDropAttachment( event ) {
      console.log("onDropFile", event);
      // TODO: This is also called in dayplanner, when dragging stuff

      /* Always prevent default and disable drop zone */
      event.preventDefault();
      this.active_drop_target = false;

      /* Return if there is already a file uploading */
      if ( this.attachment_uploading ) {
        return;
      }

      let filelist = []
      if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (event.dataTransfer.items[i].kind === 'file') {
            let file = event.dataTransfer.items[i].getAsFile();
            filelist.push(file)
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
          let file = event.dataTransfer.files[i]
          filelist.push( file )
        }
      }

      if ( filelist.length === 0 ) {
        event.stopPropagation();
        return
      }

      if ( filelist.length > 5 ) {
        this.$message.error('Maximum number of allowed files is 5.');
        return
      }

      /* Upload files */
      let promises = []
      this.attachment_uploading = true;
      filelist.forEach(file => {
        promises.push(this.$api.task_drop_file({
          goal_id:   this.goalId,
          member_id: this._memberId(),
          task_id:   this.task.$id,
          file:      file
        }));
      });
      Promise.all(promises).then(url => {
        this.attachment_uploading = false;
        // this.imageDisplayURL = url;
      }).catch(error => {
        this.attachment_uploading = false;
        this.$message.error('File upload failed. Please try again. Error message: ' + error.message);
        console.warn("File upload failed:", error);
      })
    },

    onDeleteAttachment( attachment_id ) {
      console.log("onDeleteAttachment", attachment_id);
      this.$api.task_delete_file({
        goal_id:        this.goalId,
        member_id:      this._memberId(),
        task_id:        this.task.$id,
        attachment_id:  attachment_id
      }).catch(error => {
        this.$message.error('Deletion failed. Please try again. Error message: ' + error.message);
        console.warn("File upload failed:", error);
      });
    },
  }
}
